module.exports = __webpack_public_path__ + "img/201805-3.9679dbfc.jpeg";